import axios, { AxiosError } from 'axios';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

import { auth } from '@/repo/firebase';
import store from '@/store';

// interface IAppAuth {
//   user: firebase.User | null;
// }

@Module({
  dynamic: true,
  name: 'appAuth',
  store,
})
export class AppAuth extends VuexModule {
  private user: firebase.User | null = null;
  private succeed: boolean | null = null; // まだ認証処理が行われていないときはnull

  get isLoggedIn(): boolean {
    return this.user != null;
  }

  get loggedInUser(): firebase.User | null {
    return this.user;
  }

  get succeedSignIn() {
    return this.succeed;
  }

  @Mutation
  setUser(user: firebase.User | null): void {
    console.log(`serUser: user=${user?.email}`);
    this.user = user;
  }

  @Mutation
  setSucceedLogin(login: boolean | null) {
    console.log('succeed login', login);

    this.succeed = login;
  }

  @Action({})
  startWatchingAuthState(): void {
    auth.onAuthStateChanged(user => {
      this.setUser(user);
      this.setSucceedLogin(user != null);
    });
  }

  @Action({})
  async logout(): Promise<void> {
    return await auth.signOut();
  }
}
export default getModule(AppAuth);
